export enum FmsSubMenu {
    MasterProfit = "MasterProfit",
    MasterProfitHBL = "MasterProfitHBL",
    OICargoManifest = "OICargoManifest",
    OOCargoManifest = "OOCargoManifest",
    AICargoManifest = "AICargoManifest",
    AOCargoManifest = "AOCargoManifest",
    FolderLabel = "FolderLabel",
    OutOfStateLog = "OutOfStateLog",
    ArrivalNotice = "ArrivalNotice",
    _2ndArrivalNotice = "2ndArrivalNotice",
    WorkSheet = "WorkSheet",
    OIHouseBL = "OIHouseBL",
    HouseProfit = "HouseProfit",
    CarrierCertificate = "CarrierCertificate",
    ExdecTransit = "ExdecTransit",
    DockReceipt = "DockReceipt",
    MasterSet = "MasterSet",
    TelexReleaseMessage = "TelexReleaseMessage",
    OOHBook = "OOHBook",
    OEUSDA = "OEUSDA",
    AuthEntry = "AuthEntry",
    TsaSecurity = "TsaSecurity",
    TsaUnknown = "TsaUnknown",
    WReceipt = "WReceipt",
    WShip = "WShip",
    WLabelReceive = "WLabelReceive",
    WLabelShip = "WLabelShip",
    FArrivalNotice = "FArrivalNotice",
    Invoice = "Invoice",
    PuInvoice = "PuInvoice",
    PrintCheckSlip = "PrintCheckSlip",
    PrintMessengerSlip = "PrintMessengerSlip",
    STARCFSMANI = "STARCFSMANI",
    CPHistory = "CPHistory",
    BPHistory = "BPHistory",
    MPHistory = "MPHistory",
    CompanyProfile = "CompanyProfile",
    SendEmail = "SendEmail",
    SendFax = "SendFax",
    IssueReady = "IssueReady",
    AesAir = "AesAir",
    AesOcean = "AesOcean",
    AesOtherOP = "AesOtherOP",
    AmsFiling = "AmsFiling",
    IsfFiling = "IsfFiling",
    BTCargoReceipt = "BTCargoReceipt",
    BTManifestCO = "BTManifestCO",
    BTManifestShip = "BTManifestShip",
    BTManifestBrok = "BTManifestBrok",
    BTWorkSheet = "BTWorkSheet",
    BTCntrStatusMemo = "BTCntrStatusMemo",
    BTFreightInvoice = "BTFreightInvoice",
    BTMasterDeliverySheet = "BTMasterDeliverySheet",
    BTDeliveryInstruction = "BTDeliveryInstruction",
    BTLoadInstruction = "BTLoadInstruction",
    BTUnloadInstruction = "BTUnloadInstruction",
    BTDeliveryOrder = "BTDeliveryOrder",
    BTDeliveryOrderC = "BTDeliveryOrderC",
    BTBillOfLading = "BTBillOfLading",
    BTBillOfLadingC = "BTBillOfLadingC",
    BTCNTRTracking = "BTCNTRTracking",
    IsfUpload = "IsfUpload",

    // for billings menu
    CrDbNote = "CrDbNote",
    NewCustomerPay = "NewCustomerPay",
    NewBillPay = "NewBillPay",
    CustomerPayList = "CustomerPayList",
    BillPayList = "BillPayList",
    SwitchJournal = "SwitchJournal",
    OpenHistoryView = "OpenHistoryView",
    OpenDeleteHistoryView = "OpenAcctDeleteHistoryView",
    PrintBill = "PrintBill",
    BatchPrint = "BatchPrint",
    ViewPaymenHistory = "ViewPaymenHistory",
    AIAWB = "AIAWB",
    AutoBillingView = "ViewAutoBilling",
}

